import React from 'react';
import { useTranslation } from '@/src/i18n';
import RgpdNavigation from '../../molecules/RgpdNavigation/RgpdNavigation';

type Props = {
  children: React.ReactNode;
};

const RgpdPage = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="legal page">
      <RgpdNavigation />
      <div className="legal__content">
        <img
          alt={t('security_of_your_data')}
          aria-hidden="true"
          src="/static/images/pages_illu/man-padlock.svg"
          className="floating-image"
        />
        {children}
      </div>
    </div>
  );
};
export default RgpdPage;
